<div class="modal-header">
    <h5 class="modal-title">Document View</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close" data-bs-dismiss="modal"></button>
</div>

<div class="modal-body" style="height: 80vh;">
    <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="100%" frameborder="0"></iframe>
    <div *ngIf="!pdfSrc" class="text-center p-3">Loading document...</div>
</div>


<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>
